<div class="step-content">
  <mat-horizontal-stepper [linear]="false" [selectedIndex]="currentStepIndex" class="stepperBulkExport" #stepper
    (selectionChange)="onStepChange($event)" [animationDuration]="'0ms'">
    <mat-step *ngFor="let step of steps; let i = index" [completed]="false">
      <ng-template matStepLabel>
        <i class="bi {{ getStepIcon(i) }} {{ getStepIConStatus(i) }}" aria-hidden="true"></i>
        <span [ngStyle]="{ 'font-weight': i === currentStepIndex ? 'bold' : 'normal' }" title="{{ step.tooltip }}">
          &nbsp;{{ step.label }}
        </span>
      </ng-template>
      <div *ngIf="this.step.type === 'form'" class="stepper-content-frame">
        <div class="fixed-section">
          <formly-form [form]="title[0].form" [fields]="title[0].fields" [model]="model"></formly-form>
        </div>
        <div class="filters-applied">
          <span class="text-fixed" title="Filters selected to run the exports"><b>Selected Filters:</b> {{ filtersApplied() }}</span><br><span class="simulated-link" title="Click here to see all filters applied" (click)="showFiltesrsApplied()">See more</span>
        </div>
        <div class="scroll-container">
          <!-- Show Formly form -->
          <formly-form [form]="step.form" [fields]="step.fields" [model]="model">
          </formly-form>
        </div>
      </div>
      <!-- Show Request Viewer -->
      <div *ngIf="this.step.type === 'viewer'" class="stepper-content-frame">
        <app-request-viewer [operationSource]="BulkOperationSourceEnum.EXPORT"></app-request-viewer>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>